import React from "react";
import PropTypes from "prop-types";
import Q360EmptyState from "../UI/States/Q360EmptyState";

function StudioExplorerNode({ node, selectedId, onSelect, depth = 0 }) {
  const isSelected = selectedId === node.id;
  const hasChildren = Array.isArray(node.children) && node.children.length > 0;

  return (
    <li className="studio-explorer-node">
      <button
        type="button"
        className={`studio-explorer-item ${isSelected ? "studio-explorer-item--selected" : ""}`}
        style={{ paddingLeft: `${12 + depth * 16}px` }}
        onClick={() => onSelect?.(node)}
      >
        <span className={`studio-explorer-icon studio-explorer-icon--${node.type || "item"}`} />
        <span className="studio-explorer-label">{node.label}</span>
      </button>

      {hasChildren && (
        <ul className="studio-explorer-children">
          {node.children.map((child) => (
            <StudioExplorerNode
              key={child.id}
              node={child}
              selectedId={selectedId}
              onSelect={onSelect}
              depth={depth + 1}
            />
          ))}
        </ul>
      )}
    </li>
  );
}

StudioExplorerNode.propTypes = {
  node: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    type: PropTypes.string,
    children: PropTypes.array,
  }).isRequired,
  selectedId: PropTypes.string,
  onSelect: PropTypes.func,
  depth: PropTypes.number,
};

export default function StudioExplorer({
  title = "Studio",
  nodes = [],
  selectedId = null,
  onSelect = null,
  emptyLabel = "Aucun élément",
}) {
  return (
    <nav className="studio-explorer" aria-label={title}>
      <header className="studio-explorer-header">
        <p className="studio-explorer-eyebrow">Explorer</p>
        <h3>{title}</h3>
      </header>

      {nodes.length > 0 ? (
        <ul className="studio-explorer-tree">
          {nodes.map((node) => (
            <StudioExplorerNode
              key={node.id}
              node={node}
              selectedId={selectedId}
              onSelect={onSelect}
            />
          ))}
        </ul>
      ) : (
        <Q360EmptyState
          message={emptyLabel}
          compact
          className="studio-explorer-empty"
        />
      )}
    </nav>
  );
}

StudioExplorer.propTypes = {
  title: PropTypes.string,
  nodes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      type: PropTypes.string,
      children: PropTypes.array,
    })
  ),
  selectedId: PropTypes.string,
  onSelect: PropTypes.func,
  emptyLabel: PropTypes.string,
};
